import { Tab, Tabs } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import MemberSearchPage from "./MemberSearchPage";
import EventSearchPage from "./EventSearchPage";
import CommitteeSearchPage from "./CommitteeSearchPage";
import Page from "../../components/Page";
import "../../styles/AdminPage.css";
import { ReactComponent as GearIcon } from '../../assets/images/settings-gear.svg';
import { Link } from 'react-router-dom';
import { useAdmin } from "./AdminContext";
import ErrorPage from "../ErrorPage";

export default function AdminPage() {
    // TODO: add backend call to get these in AdminContext
    const { roles, apiSuccess } = useAdmin();
    const { tab } = useParams();
    const navigate = useNavigate();

    const activeTab = tab || "members";

    // TODO: change pages based on committee role
    const correctRolesForSettings = ["ADMIN", "LOGHEAD"].some(r => roles.includes(r));
    const correctRolesForMemberLink = ["MEMBER"].some(r => roles.includes(r));

    const handleTabSelect = (key) => {
        navigate(`/admin/${key}`);
    };

    return (
        <>
        {!apiSuccess && <ErrorPage />}
        {apiSuccess && (
            <Page className="w-100">
                
                <div className="container-fluid p-0">
                    <div className="d-flex flex-row justify-content-between">
                        <h1 className="mb-3 text-start">Admin Dashboard</h1>
                        <div style={{ display: 'flex', alignItems: 'center', paddingRight: '2%'}}>
                            {(correctRolesForMemberLink) && (
                                <div style={{ whiteSpace: 'nowrap', marginRight: '20px'}}>
                                    <Link to={"/member/dashboard"}>Member Dashboard</Link>
                                </div>
                            )}
                            {(correctRolesForSettings) && (
                                <div>
                                    <Link to="/admin/settings">
                                        <GearIcon width={40} height={40} fill='#4D1F5B' style={{ cursor: 'pointer' }} />
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="p-0 w-100">
                        <Tabs
                            activeKey={activeTab}
                            onSelect={handleTabSelect}
                            id="admin-tabs"
                            className="mb-3 w-100 custom-tabs"
                            unmountOnExit
                        >
                            <Tab eventKey="members" title="Members">
                                <div className="p-0 bg-white w-100">
                                    <MemberSearchPage
                                        key="members"
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="events" title="Events">
                                <div className="p-0 bg-white w-100">
                                    <EventSearchPage
                                        key="events"
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="committees" title="Committees">
                                <div className="p-0 bg-white w-100">
                                    <CommitteeSearchPage
                                        key="committees"
                                    />
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </Page>
        )}
    </>
    );
}
